import { invoiceItemParamKey, invoiceParamKey, Route } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export const setCombineRouteQueries = async (route: Route) => {
    await route.addFilter({
        column: 'invoice_uuid',
        operator: '=',
        value: null,
    })

    await route.addSortItem({
        column: 'created_at',
        direction: 'desc',
    })
}

export enum CompanyBillingRouteName {
    Index = 'company.billing.index',
    Multiple = 'company.billing.multiple',
    MultipleSend = 'company.billing.multiple.send',
    Single = 'company.billing.single',
    Product = 'company.billing.product',
    Combine = 'company.billing.combine',
    CombineSend = 'company.billing.combine.send',
    CombineEditInvoiceItem = 'company.billing.combine.edit-invoice-item',
}

export default {
    path: 'billing',
    name: CompanyBillingRouteName.Index,
    component: () => import('@/views/company/billing/Index.vue'),
    meta: {
        label: 'Billing',
        auth: true,
        permission: Permission.InvoiceCreate,
    },
    children: [
        {
            path: 'multiple',
            name: CompanyBillingRouteName.Multiple,
            component: () => import('@/views/company/billing/multiple/Index.vue'),
            meta: {
                label: 'Multiple Service Billing',
                auth: true,
                permission: Permission.InvoiceCreate,
            },
            children: [
                {
                    path: `:${invoiceParamKey}/send`,
                    name: CompanyBillingRouteName.MultipleSend,
                    component: () => import('@/views/company/billing/multiple/Index.vue'),
                    meta: {
                        label: 'Invoice Send',
                        auth: true,
                        permission: Permission.InvoiceSend,
                    },
                },
            ],
        },
        {
            path: 'single',
            name: CompanyBillingRouteName.Single,
            component: () => import('@/views/company/billing/single/Index.vue'),
            meta: {
                label: 'Single Service Billing',
                auth: true,
                permission: Permission.InvoiceCreate,
            },
        },
        {
            path: 'product',
            name: CompanyBillingRouteName.Product,
            component: () => import('@/views/company/billing/product/Index.vue'),
            meta: {
                label: 'Product Billing',
                auth: true,
                permission: Permission.InvoiceCreate,
            },
        },
        {
            path: 'combine',
            name: CompanyBillingRouteName.Combine,
            component: () => import('@/views/company/billing/combine/Index.vue'),
            meta: {
                label: 'Combine Invoice Item',
                auth: true,
                permission: Permission.InvoiceCreate,
            },
            children: [
                {
                    path: `:${invoiceItemParamKey}/edit`,
                    name: CompanyBillingRouteName.CombineEditInvoiceItem,
                    component: () => import('@/views/company/billing/combine/Index.vue'),
                    meta: {
                        label: 'Edit Invoice Item',
                        auth: true,
                        permission: Permission.InvoiceItemUpdate,
                    },
                },
                {
                    path: `:${invoiceParamKey}/send`,
                    name: CompanyBillingRouteName.CombineSend,
                    component: () => import('@/views/company/billing/combine/Index.vue'),
                    meta: {
                        label: 'Invoice Send',
                        auth: true,
                        permission: Permission.InvoiceSend,
                    },
                },
            ],
        },
    ],
}
